import { useFetchInspectorProfile } from "../../Onboarding/Inspector/hooks/useFetchInspectorProfile";
import { HudDetails } from "./HudDetails";
import { LicenseDetails } from "./LicenseDetails";
import { TaxInformationDetails } from "./TaxInformationDetails";
import { ServiceAreas } from "./ServiceAreas";
import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";
import AddressDetails from "./AddressDetails";
import { SectionSkeleton } from "@/components/profile-cards";

const InspectorDetailsSections = () => {
  const { profile } = useFetchInspectorProfile();

  if (!profile) {
    return (
      <>
        <SectionSkeleton />
        <SectionSkeleton />
        <SectionSkeleton />
      </>
    );
  }

  return (
    <>
      <AddressDetails profile={profile} />
      <ServiceAreas
        userId={profile.userId}
        serviceAreas={profile.serviceAreas}
      />
      <HudDetails userId={profile.userId} hudDetails={profile.hudDetail} />
      <LicenseDetails userId={profile.userId} license={profile.license} />
      <TaxInformationDetails userId={profile.userId} w9Form={profile.w9Form} />
    </>
  );
};

const InspectorDetails = () => {
  const user = useAppStore((s) => s.user);

  if (user?.role === UserRole.Inspector) return <InspectorDetailsSections />;

  return null;
};

export default InspectorDetails;
